const getUnappliedVoucherCodes = (vouchers, appliedDiscounts) => vouchers?.filter((voucher) => !appliedDiscounts.some(({ code }) => code === voucher.code));
export {
  getUnappliedVoucherCodes
};
//# sourceMappingURL=get-unapplied-voucher-codes.js.map
